import Vue from 'vue'
Vue.use(require('vue-moment'))
export default {
  typeText: 'text',
  typeAvatar: 'avatar',
  typeJSON: 'json',
  typeSelect:'select',
  typeMultiSelect:'multiSelect',
  typeDate: 'date',
  typeDateTime: 'dateTime',
  typeCountry: 'country',
  typeEmail: 'email',
  typePhone: 'phone',
  typeProvince: 'province',
  typeNotes: 'notes',
  typeCurrency: 'currency',
  typeProductData: 'productData',
  typePayments: 'payments',
  typeImages: 'images',
  typeImage: 'image',
  typeFiles: 'files',
  typeCheckbox: 'checkbox',
  typeDatePicker: 'datePicker',
  typeSignature: 'signature',
  typeSignatureImage: 'signatureImage',
  typeTime: 'time',
  typeLabel: 'label',
  typeTitle: 'title',
  typeColor: 'color',
  typeEditor: 'editor',
  typeLongText: 'longText',
  typeInt: 'int',
  typeBool: 'bool',
  typeHTML: 'html',
  typeCCDefault: 'ccDefault',
  typeProductStandardSummary: 'productStandardSummary',
  typeProductLimitedSubscriptionSummary: 'productLimitedSubscriptionSummary',
  typeProductRecurringSubscriptionSummary: 'productRecurringSubscriptionSummary',
  typeBookingSummary: 'bookingSummary',
  typeCartOptions: 'cartOptions',
  typeParticipant: 'participant',
  typeConditional: 'conditional',
  typeInstanceSelector: 'instanceSelector',
  typeMultipleInstanceSelector: 'multipleInstanceSelector',
  typeUserBookings: 'userBookings',
  typeSpreadsheet: 'spreadsheet',
  fieldIcon(field) {
    switch(field) {
      case this.typeText:
        return "<i class='fa fa-edit'></i>"
        break
      case this.typeEditor:
        return "<i class='fa fa-edit'></i>"
        break
      case this.typeHTML:
        return "<i class='fa fa-code'></i>"
        break
      case this.typeLongText:
        return "<i class='fa fa-edit'></i>"
        break
      case this.typeAvatar:
        return "<i class='fa fa-picture-o'></i>"
        break
      case this.typeSelect:
        return "<i class='fa fa-list-ul'></i>"
        break
      case this.typeMultiSelect:
        return "<i class='fa fa-list-ul'></i>"
        break
      case this.typeDate:
        return "<i class='fa fa-calendar'></i>"
        break
      case this.typeEmail:
        return "<i class='fa fa-envelope'></i>"
        break
      case this.typePhone:
        return "<i class='fa fa-phone'></i>"
        break
      case this.typeCheckbox:
        return "<i class='fa fa-check'></i>"
        break
      case this.typeSignature:
        return "<i class='fa fa-pencil'></i>"
        break
      case this.typeImage:
        return "<i class='fa fa-image'></i>"
        break
      case this.typeImages:
        return "<i class='fa fa-files-o'></i>"
        break
      case this.typeLabel:
        return "<i class='fa fa-file-text'></i>"
        break
      case this.typeTitle:
        return "<i class='fa fa-font'></i>"
        break
      case this.typeInstanceSelector:
        return "<i class='fa fa-search'></i>"
        break
      case this.typeSpreadsheet:
        return "<i class='fa fa-table'></i>"
        break
    }
  },
  fieldLabel(field) {
    switch(field) {
      case this.typeText:
        return Core.Definition.getDefinition('Texte');
        break
      case this.typeEditor:
        return Core.Definition.getDefinition('WYSIWYG');
        break
      case this.typeHTML:
        return Core.Definition.getDefinition('HTML');
        break
      case this.typeLongText:
        return Core.Definition.getDefinition('Texte long');
        break
      case this.typeAvatar:
        return Core.Definition.getDefinition('Avatar');
        break
      case this.typeSelect:
        return Core.Definition.getDefinition('Selection');
        break
      case this.typeMultiSelect:
        return Core.Definition.getDefinition('Multi-Selection');
        break
      case this.typeDate:
        return Core.Definition.getDefinition('Date');
        break
      case this.typeEmail:
        return Core.Definition.getDefinition('Courriel');
        break
      case this.typePhone:
        return Core.Definition.getDefinition('Téléphone');
        break
      case this.typeCheckbox:
        return Core.Definition.getDefinition('Case à cocher');
        break
      case this.typeSignature:
        return Core.Definition.getDefinition('Signature');
        break
      case this.typeSignatureImage:
        return Core.Definition.getDefinition('Signature Image');
        break
      case this.typeImage:
        return Core.Definition.getDefinition('Image');
        break
      case this.typeImages:
        return Core.Definition.getDefinition('Images mutiple');
        break
      case this.typeTitle:
        return Core.Definition.getDefinition('Titre');
        break
      case this.typeLabel:
        return Core.Definition.getDefinition('Label');
        break
      case this.typeInstanceSelector:
        return Core.Definition.getDefinition('Sélecteur');
        break
      case this.typeSpreadsheet:
        return Core.Definition.getDefinition('Feuille de calcule');
        break
      default:
        return ''
        break
    }
  },
  fieldOptions(keys) {
    if (keys === undefined) {
      keys = [this.typeText, this.typeAvatar, this.typeSelect, this.typeMultiSelect, this.typeDate,this.typeHTML, this.typeEmail, this.typePhone, this.typeCheckbox, this.typeSignature, this.typeImage, this.typeImages, this.typeSpreadsheet, this.typeSignatureImage]
    }
    let options = []
    for(let key in keys) {
      key = keys[key]
      options.push(
          {
            value: key,
            label: this.fieldLabel(key)
          }
      )
    }
    return options
  },
  readable(type, key, value, options) {
    switch(type) {
      case Core.Value.typeSelect:
        if (options[key] !== undefined) {
          value = Core.Select.label(value, options[key])
        } else {
          value = Core.Select.label(value, options)
        }
        break
      case Core.Value.typeCurrency:
        value = Core.Currency.format(value)
        break
      case Core.Value.typeDate:
        value = Core.Date.format(value, 'DD MMM YYYY')
        break
      case Core.Value.typeDateTime:
        value = Core.Date.format(value, 'DD MMM YYYY HH:mm')
        break
      case Core.Value.typeTime:
        let time = value.split(':')
        return time[0] + 'hr(s) ' + time[1] + 'min(s)'
        break
    }
    if (value === '' || value === undefined || value === null) {
      value = '-'
    }
    return value
  },
  selectValue(value, options) {
    for(let option in options) {
      option = options[option]
      if (option.value == value) {
        return option
      }
    }
    return null
  },
  encode(value, type, selectOptions) {
    switch(type) {
      case this.typeLongText:
      case this.typeEditor:
      case this.typeText:
        if (Core.Validation.isJSON(value)) {
          value = JSON.parse(value)
        }
        break;
      case this.typeSpreadsheet:
        if (value !== ''&& value !== undefined) {
          if (!Array.isArray(value)) {
            value = JSON.parse(value)
          }
        }
        break
      case this.typeAvatar:
        value =  {
          src: value
        }
        break
      case this.typeInstanceSelector:
        if (value === undefined || value === '') {
          value = {
            id: '',
            label: ''
          }
        } else {
          if (!Core.Validation.isId(value.id)) {
            value = {
              id: '',
              label: ''
            }
          }
        }
        break
      case this.typeMultipleInstanceSelector:
        if (value === undefined || value === '' || value == null) {
          value = []
        } else {
          if (!Array.isArray(value)) {
            value = JSON.parse(value)
          }
        }
        break
      case this.typeDatePicker:
        if (value !== '' && value !== undefined && Vue.moment(value).isValid()) {
          value = new Date(value + 'T00:00')
        }
        break
      case this.typeProductRecurringSubscriptionSummary:
        if (!Array.isArray(value) && typeof value !== 'object') {
          value = JSON.parse(value)
        }
        if (value.period === null || (value.period !== undefined && value.period.value === undefined)) {
          value.period = Core.Select.select(value.period, Core.Product.periodOptions())
        }
        if (value.periodPayment === null || (value.periodPayment !== undefined && value.periodPayment.value === undefined)) {
          value.periodPayment = Core.Select.select(value.periodPayment, Core.Product.periodOptions())
        }
        if (value.periodPaymentInterval === null || (value.periodPaymentInterval !== undefined && value.periodPaymentInterval.value === undefined)) {
          value.periodPaymentInterval = Core.Select.select(value.periodPaymentInterval, Core.Product.periodIntervalOptions())
        }
        if (value.bookingLimitPeriod === null || (value.bookingLimitPeriod !== undefined && value.bookingLimitPeriod.value === undefined)) {
          value.bookingLimitPeriod = Core.Select.select(value.bookingLimitPeriod, Core.Product.periodOptions())
        }
        if (value.bookingLimitInterval === null || (value.bookingLimitInterval !== undefined && value.bookingLimitInterval.value === undefined)) {
          value.bookingLimitInterval = Core.Select.select(value.bookingLimitInterval, Core.Product.periodIntervalOptions())
        }
        if (value.bookingLimitManagement !== undefined) {
          value.bookingLimitManagement = Core.Value.encode(value.bookingLimitManagement, this.typeCheckbox)
        }
        if (value.start !== undefined) {
          value.start = Core.Value.encode(value.start, 'datePicker')
        }
        if (value.end !== undefined) {
          value.end = Core.Value.encode(value.end, 'datePicker')
        }
        break
      case this.typeProductData:
        if (!Array.isArray(value) && typeof value !== 'object') {
          value = JSON.parse(value)
        }
        if (value.type === null || (value.type !== undefined && value.type.value === undefined)) {
          value.type = Core.Select.select(value.type, Core.Product.typeOptions())
        }
        if (value.period === null || (value.period !== undefined && value.period.value === undefined)) {
          value.period = Core.Select.select(value.period, Core.Product.periodOptions())
        }
        if (value.periodPayment === null || (value.periodPayment !== undefined && value.periodPayment.value === undefined)) {
          value.periodPayment = Core.Select.select(value.periodPayment, Core.Product.periodOptions())
        }
        if (value.expirationPeriod === null || (value.expirationPeriod !== undefined && value.expirationPeriod.value === undefined)) {
          value.expirationPeriod = Core.Select.select(value.expirationPeriod, Core.Product.periodOptions())
        }
        if (value.periodPaymentInterval === null || (value.periodPaymentInterval !== undefined && value.periodPaymentInterval.value === undefined)) {
          value.periodPaymentInterval = Core.Select.select(value.periodPaymentInterval, Core.Product.periodIntervalOptions())
        }
        if (value.bookingLimitPeriod === null || (value.bookingLimitPeriod !== undefined && value.bookingLimitPeriod.value === undefined)) {
          value.bookingLimitPeriod = Core.Select.select(value.bookingLimitPeriod, Core.Product.periodOptions())
        }
        if (value.bookingLimitInterval === null || (value.bookingLimitInterval !== undefined && value.bookingLimitInterval.value === undefined)) {
          value.bookingLimitInterval = Core.Select.select(value.bookingLimitInterval, Core.Product.periodIntervalOptions())
        }
        if (value.bookingLimitManagement !== undefined) {
          value.bookingLimitManagement = Core.Value.encode(value.bookingLimitManagement, this.typeCheckbox)
        }
        if (value.stockManagement !== undefined) {
          value.stockManagement = Core.Value.encode(value.stockManagement, this.typeCheckbox)
        }
        if (value.isTaxable !== undefined) {
          value.isTaxable = Core.Value.encode(value.isTaxable, this.typeCheckbox)
        }
        if (value.ticketIsEnabled !== undefined) {
          value.ticketIsEnabled = Core.Value.encode(value.ticketIsEnabled, this.typeCheckbox)
        }
        if (value.ticketTemplate !== undefined || (value.ticketTemplate !== undefined && value.ticketTemplate.value === undefined)) {
          value.ticketTemplate = Core.Select.select(value.ticketTemplate, selectOptions.ticketTemplate)
        }
        break
      case this.typeCheckbox:
        if (value == 1 || value == 'true') {
          value = true
        } else {
          value = false
        }
        break
      case this.typeBool:
        if (value == 1 || value == 'true') {
          value = true
        } else {
          value = false
        }
        break
      case this.typeColor:
        if (value === undefined || value == '') {
          value = {}
        } else {
          if (!Array.isArray(value)) {
            value = JSON.parse(value)
          }
        }
        break
      case this.typeNotes:
        if (value !== ''&& value !== undefined) {
          if (!Array.isArray(value)) {
            value = JSON.parse(value)
          }
        } else {
          value = []
        }
        break
      case this.typeBookingSummary:
      case this.typeProductStandardSummary:
      case this.typeProductLimitedSubscriptionSummary:
      case this.typeFiles:
      case this.typeSignatureImage:
      case this.typeImages:
      case this.typeImage:
      case this.typeJSON:
        if (value !== ''&& value !== undefined) {
          if (!Array.isArray(value)) {
            value = JSON.parse(value)
          }
        }
        break
      case this.typeMultiSelect:
        if (value === undefined || value === '' || value === null) {
          value = []
        }
        if (!Array.isArray(value)) {
          value = value.split(',')
        }
        if (Array.isArray(value)) {
          let values = value
          for(let valueIndex in values) {
            value = values[valueIndex]
            for(let option in selectOptions) {
              option = selectOptions[option]
              if (option.value == value.toString()) {
                values[valueIndex] = option
              }
            }
          }
          value = values
        }
        break
      case this.typeSelect:
      case this.typeCountry:
      case this.typeProvince:
        for(let option in selectOptions) {
          option = selectOptions[option]
          if (option.value == value) {
            value = option
          }
        }
        break
      case this.typeCurrency:
        let formatter = new Intl.NumberFormat('fr-CA', {
          style: 'currency',
          currency: Core.Setting.getSetting('currency'),
        });
        value = formatter.format(value)
        break
    }
    return value
  },
  // Preparation à envoyer vers le serveur
  decode(value, type) {
    switch(type) {
      case this.typeUserBookings:
        let userBookings = []
        if (Array.isArray(value)) {
          for(let userBooking in value) {
            userBooking = value[userBooking]
            if (!Core.Validation.isEmpty(userBooking.status)) {
              if (!Core.Validation.isEmpty(userBooking.status.value)) {
                userBooking.status = userBooking.status.value
              }
            }
            if (!Core.Validation.isEmpty(userBooking.eventDateId)) {
              if (!Core.Validation.isEmpty(userBooking.eventDateId.value)) {
                userBooking.eventDateId = userBooking.eventDateId.value
              }
            }
            userBookings.push(userBooking)
          }
          value = JSON.stringify(userBookings)
        } else {
          value = ''
        }
        break
      case this.typeInstanceSelector:
        if (Array.isArray(value) || typeof value === 'object') {
          if (value.id !== undefined) {
            value = value.id
          } else {
            value = ''
          }
        } else {
          value = ''
        }
        break
      case this.typeMultipleInstanceSelector:
        if (Array.isArray(value)) {
          let ids = []
          for(let index in value) {
            if (value[index].id !== undefined) {
              ids.push(value[index].id)
            }
          }
          value = ids
        } else {
          value = ''
        }
        break
      case this.typeAvatar:
        if (value !== undefined && value.src !== undefined) {
          value = value.src
        }
        break
      case this.typeDatePicker:
        if (value !== undefined && Vue.moment(value).isValid()) {
          value = Vue.moment(value).format('YYYY-MM-DD')
        }
        break
      case this.typeTime:
        if (value !== null && value !== undefined && value.HH !== undefined && value.mm !== undefined && value.HH !== null && value.HH !== 'null' && value.mm !== null && value.mm !== 'null') {
          value = value.HH + ':' + value.mm
        }
        break
      case this.typeColor:
        if (Array.isArray(value) || typeof value === 'object') {
          value = JSON.stringify(value)
        }
        break
      case this.typeProductData:
        let newObject = Core.Array.newObject(value)
        if (Array.isArray(newObject) || typeof newObject === 'object') {
          newObject.type = this.decode(newObject.type, 'select')
          newObject.period = this.decode(newObject.period, 'select')
          newObject.periodPayment = this.decode(newObject.periodPayment, 'select')
          newObject.expirationPeriod = this.decode(newObject.expirationPeriod, 'select')
          newObject.periodPaymentInterval = this.decode(newObject.periodPaymentInterval, 'select')
          newObject.bookingLimitPeriod = this.decode(newObject.bookingLimitPeriod, 'select')
          newObject.bookingLimitInterval = this.decode(newObject.bookingLimitInterval, 'select')
          newObject.regularPrice = this.decode(newObject.regularPrice, 'currency')
          newObject.ticketTemplate = this.decode(newObject.ticketTemplate, 'select')
        }
        if (Array.isArray(newObject) || typeof newObject === 'object') {
          value = JSON.stringify(newObject)
        }
        break
      case this.typePayments:
        let payments = []
        for (let payment in value) {
          payment = value[payment]

          let total = payment.subTotal
          if (payment.total !== undefined) {
            total = payment.total
          }

          let totalTaxes = 0
          if (payment.totalTaxes !== undefined) {
            totalTaxes = payment.totalTaxes
          }

          payments.push({
            status: payment.status,
            method: payment.method,
            referenceNumber: payment.referenceNumber,
            subTotal: payment.subTotal,
            total: payment.total,
            date: payment.date,
            totalTaxes: payment.totalTaxes,
            id: payment.id,
            key: payment.key
          })
        }
        value = JSON.stringify(payments)
        break
      case this.typeProductStandardSummary:
        let standardSummary = []

        for (let product in value) {
          product = value[product]

          let participant = false
          let conditional = false

          if (product.data !== undefined) {
            if (product.data.participant !== undefined) {
              participant = Core.Array.newObject(product.data.participant)
              participant.teamId = Core.Value.decode(participant.teamId, Core.Value.typeSelect)
              participant.participantCategoryId = Core.Value.decode(participant.participantCategoryId, Core.Value.typeSelect)
              participant.tshirtSize = Core.Value.decode(participant.tshirtSize, Core.Value.typeSelect)
            }

            if (product.data.conditional !== undefined) {
              conditional = Core.Array.newObject(product.data.conditional)
              conditional.seasonId = Core.Value.decode(conditional.seasonId, Core.Value.typeSelect)
              conditional.leagueId = Core.Value.decode(conditional.leagueId, Core.Value.typeSelect)
              conditional.districtId = Core.Value.decode(conditional.districtId, Core.Value.typeSelect)
              if (Array.isArray(conditional.eventDateId)) {
                conditional.eventDateId = Core.Array.extractAllByKey(conditional.eventDateId, 'id')
                conditional.eventDateId = conditional.eventDateId.join(', ')
              }
            }
          }

          let promoCode = false
          if (product.data !== undefined && product.data.promoCode !== undefined) {
            promoCode = product.data.promoCode
          }

          standardSummary.push({
            index: product.index,
            quantity: product.quantity,
            taxes: product.taxes,
            data: {
              participant: participant,
              conditional: conditional,
              promoCode: promoCode
            },
            instance: {
              id: product.instance.id,
              orderProductId: product.instance.orderProductId,
              title: product.instance.title,
              shortDescription: product.instance.shortDescription,
              isTaxable: product.instance.isTaxable,
              regularPrice: product.instance.regularPrice
            }
          })
        }
        value = JSON.stringify(standardSummary)
        break
      case this.typeProductRecurringSubscriptionSummary:
        let recurringSubscriptionSummary = {
          recurringSubscriptionProductId: value.recurringSubscriptionProductId,
          title: value.title,
          shortDescription: value.shortDescription,
          productId: value.productId,
          isTaxable: value.isTaxable,
          amount: this.decode(value.amount, 'currency'),
          period: this.decode(value.period, 'select'),
          periodPayment: this.decode(value.periodPayment, 'select'),
          periodLength: value.periodLength,
          periodPaymentInterval: this.decode(value.periodPaymentInterval, 'select'),
          periodPaymentLength: value.periodPaymentLength,
          bookingLimitManagement: value.bookingLimitManagement,
          bookingLimit: value.bookingLimit,
          bookingLimitPeriod: this.decode(value.bookingLimitPeriod, 'select'),
          bookingLimitInterval: this.decode(value.bookingLimitInterval, 'select'),
          start: this.decode(value.start, 'datePicker'),
          end: this.decode(value.end, 'datePicker')
        }
        value = JSON.stringify(recurringSubscriptionSummary)
        break
      case this.typeProductLimitedSubscriptionSummary:
        if (value[0] !== undefined) {
          let SubscriptionSummary = {
            limitedSubscriptionProductId: value[0].instance.limitedSubscriptionProductId,
            productId: value[0].instance.id,
            quantity: value[0].quantity,
            title: value[0].instance.title,
            shortDescription: value[0].instance.shortDescription,
            taxes: value[0].taxes,
            isTaxable: value[0].instance.isTaxable,
            regularPrice: this.decode(value[0].instance.regularPrice, 'currency'),
            period: this.decode(value[0].instance.period, 'select'),
            periodPayment: this.decode(value[0].instance.periodPayment, 'select'),
            periodPaymentInterval: this.decode(value[0].instance.periodPaymentInterval, 'select'),
            periodLength: value[0].instance.periodLength,
            periodPaymentLength: value[0].instance.periodPaymentLength,
            bookingLimit: value[0].instance.bookingLimit,
            bookingLimitPeriod: this.decode(value[0].instance.bookingLimitPeriod, 'select'),
            bookingLimitInterval: this.decode(value[0].instance.bookingLimitInterval, 'select'),
          }
          value = JSON.stringify(SubscriptionSummary)
        }
        break
      case this.typeCCDefault:
        let ccDefault = {
          id: value.id
        }
        value = JSON.stringify(ccDefault)
        break
      case this.typeFiles:
      case this.typeBookingSummary:
      case this.typeImages:
      case this.typeImage:
      case this.typeJSON:
      case this.typeSignatureImage:
      case this.typeNotes:
        if (!Array.isArray(value)) {
          value = []
        }
        if (Array.isArray(value) || typeof value === 'object') {
          value = JSON.stringify(value)
        }
        break
      case this.typeSpreadsheet:
        if (!Array.isArray(value)) {
          value = []
        }
        if (Array.isArray(value) || typeof value === 'object') {
          value = JSON.stringify(value)
        }
        break
      case this.typeSelect:
      case this.typeCountry:
      case this.typeProvince:
        if (value !== null && value !== undefined) {
          if (Array.isArray(value) || typeof value === 'object') {
            if (value.value !== undefined) {
              value = value.value
            }
          }
        }
        break
      case this.typeMultiSelect:
        if (Array.isArray(value) || typeof value === 'object') {
          let values = []
          for (let i in value) {
            if (value[i].value !== undefined) {
              values.push(value[i].value)
            }
          }
          value = values
          value = value.join(',')
        }
        break
      case this.typeCartOptions:
        let products = []
        if (value !== undefined && value.products !== undefined) {
          for (let product in value.products) {
            product = value.products[product]

            let participant = false
            if (product.participant !== undefined) {
              participant = Core.Array.newObject(product.participant)
              participant.teamId = Core.Value.decode(participant.teamId, Core.Value.typeSelect)
              participant.participantCategoryId = Core.Value.decode(participant.participantCategoryId, Core.Value.typeSelect)
              participant.tshirtSize = Core.Value.decode(participant.tshirtSize, Core.Value.typeSelect)
            }

            let conditional = false
            if (product.conditional !== undefined) {
              conditional = Core.Array.newObject(product.conditional)
              conditional.seasonId = Core.Value.decode(conditional.seasonId, Core.Value.typeSelect)
              conditional.leagueId = Core.Value.decode(conditional.leagueId, Core.Value.typeSelect)
              conditional.districtId = Core.Value.decode(conditional.districtId, Core.Value.typeSelect)
              if (Array.isArray(conditional.eventDateId)) {
                conditional.eventDateId = Core.Array.extractAllByKey(conditional.eventDateId, 'id')
                conditional.eventDateId = conditional.eventDateId.join(', ')
              }
            }

            products.push({
              id: product.id,
              participant: participant,
              conditional: conditional,
            })
          }
        }
        value = {
          products: products,
          forms: value.forms
        }
        break
      case this.typeParticipant:
        let participant = {
          id: value.id,
          firstname: value.firstname,
          lastname: value.lastname,
          teamId: Core.Value.decode(value.teamId, Core.Value.typeSelect),
          participantCategoryId: Core.Value.decode(value.participantCategoryId, Core.Value.typeSelect),
          tshirtSize: Core.Value.decode(value.tshirtSize, Core.Value.typeSelect),
          birthdate: value.birthdate,
          urgencyContact: value.urgencyContact,
          urgencyPhone: value.urgencyPhone,
          insuranceNumber: value.insuranceNumber,
          teamTitle: value.teamTitle,
          tshirtCustomName: value.tshirtCustomName,
          age: value.age,
          weight: value.weight
        }
        return participant
        break
      case this.typeConditional:
        let conditional = {
          seasonId: Core.Value.decode(value.seasonId, Core.Value.typeSelect),
          leagueId: Core.Value.decode(value.leagueId, Core.Value.typeSelect),
          districtId: Core.Value.decode(value.districtId, Core.Value.typeSelect),
        }
        if (Array.isArray(value.eventDateId)) {
          conditional.eventDateId = Core.Array.extractAllByKey(value.eventDateId, 'id')
          if (Array.isArray(conditional.eventDateId)) {
            conditional.eventDateId = conditional.eventDateId.join(', ')
          }
        }
        return conditional
        break
      case this.typeLongText:
      case this.typeEditor:
      case this.typeText:
      case this.typeHTML:
        if (!Core.Validation.isEmpty(value)) {
          if (Array.isArray(value) || typeof value === 'object') {
            value = JSON.stringify(value);
          }
          value = encodeURIComponent(value)
        }
      default:
        break
    }
    if (value === undefined||value === null) {
      value = ''
    }
    return value
  }
}
